// caiet UC91-12 / UC93-05 (TC-UC91-12-01, TC-UC93-05-01) — a Registrar offered in a
// filter reads «denumire + IDNO»: the name alone cannot tell two institutions of
// the same name apart, and an IDNO alone says nothing to the reader. A Registrar
// the catalogue holds no name for is already its IDNO, and is printed once.
export function registrarFacetLabel(name: string, idno: string): string {
  const trimmed = name.trim();
  return trimmed.length === 0 || trimmed === idno ? idno : `${trimmed} · ${idno}`;
}
